<template>
    <div>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
        <div class="show-destop" v-bind:style="configs.themes?.main_background_url ? { 'background-image': 'url(' + configs.themes?.main_background_url + ')' } : ''">
            <nav-bar />

            <div id="mainContent" class="container-fluid">
                <!-- <div class="left-corner" v-bind:style="{ content: 'url(' + configs.themes?.left_content + ')' }" v-if="configs.themes?.left_content"></div>
                <div class="right-corner" v-bind:style="{ content: 'url(' + configs.themes?.right_content + ')' }" v-if="configs.themes?.right_content"></div> -->
                <div class="left-corner"></div>
                <div class="right-corner"></div>
                <side-bar />
                <main id="main" class="ms-sm-auto">
                    <div class="banner-text" v-if="$store.state.user_info.contest_info.id !== 0">
                        <div class="d-flex align-items-center gap-3">
                            <p class="banner-link">{{ $t('event_text_marquee', {
                                name: $store.state.user_info.contest_info.contest_name, start:
                                    moment($store.state.user_info.contest_info.start_time).format('DD/MM/YYYY'), end: moment($store.state.user_info.contest_info.end_time).format('DD/MM/YYYY')
                            }) }}</p>

                            <a :href="$store.state.user_info.contest_info.upload_video_url" class="btn btn-orange-gradient d-flex gap-1 align-items-center" target="_blank"
                                v-if="$store.state.user_info.contest_info.id != 0 && $store.state.user_info.contest_info.upload_video_url && $store.state.user_info.contest_info.upload_video_url !== ''">
                                <AppIcon src="/themes/ito/images/icons/video_camera.svg" :size="21" />
                                <span>{{ $t('upload_video') }}</span>
                            </a>
                        </div>
                    </div>
                    <router-view>
                    </router-view>
                </main>

                <div class="modal fade" id="selectLangModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="languageModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 264px; max-height: 216px; padding-top: calc(50vh - 100px)">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ $t('choose_language') }}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <ul class="languages">
                                    <li :class="locate == localize.lang ? 'active' : ''" @click="setLocate(localize)" v-for="(localize, index) in configs.localize" :key="index">
                                        <div class="flag">
                                            <img :src="localize.img_flag" alt="">
                                        </div>
                                        <div class="title">{{ $t(localize.lang) }}</div>
                                        <i class="lisa-icon-checked-1"></i>
                                    </li>
                                </ul>
                            </div>
                            <div class="modal-footer">
                                <button type="button" data-bs-dismiss="modal" @click="updateLocate()" class="lisa-btn-fit active">{{ $t('confirm') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade modal-flex" id="settingModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="settingModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 360px;">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ $t('settings') }}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <ul class="settings">
                                    <li>
                                        <i class="lisa-icon-account-sound"></i>
                                        <span>{{ $t('sound_effect') }}</span>
                                        <div class="checkbox-2">
                                            <input type="checkbox" id="setting-sound-effect" v-model="setting_sound" @change="updateSetingSound" />
                                            <label for="setting-sound-effect"></label>
                                        </div>
                                    </li>
                                    <li>
                                        <i class="lisa-icon-account-music"></i> <span>{{ $t('music_background') }}</span>
                                        <div class="checkbox-2">
                                            <input type="checkbox" id="setting-music-bg" v-model="setting_music_background" @change="updateSetingMusic" />
                                            <label for="setting-music-bg"></label>
                                        </div>
                                    </li>
                                    <li>
                                        <i class="lisa-icon-account-noti"></i> <span>{{ $t('notifications') }}</span>
                                        <div class="checkbox-2">
                                            <input type="checkbox" id="setting-noti" :true-value="'activated'" :false-value="'deactivated'" v-model="parent_setting.notification_active" @change="updateSetingNofification" />
                                            <label for="setting-noti"></label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade modal-flex" id="exchangeGiftModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="exchangeGiftModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 660px; max-width: 660px;">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">All programs</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-1">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-1.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                iSMART
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-2 active">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-2.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                iGS-Bridge
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-3">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-1.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                General English
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-4">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-2.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                iSMART
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-5">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-1.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                iGS-Bridge
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="thumb-exchange-gift exchange-gift-6">
                                            <div class="thumb-exchange-gift-img">
                                                <img src="/themes/web/assets/images/program-2.svg" alt="" />
                                            </div>
                                            <div class="thumb-exchange-gift-title">
                                                General English
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-confirm m-auto" style="padding: 8px 57px;">SAVE</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade modal-flex" id="welcomeBackModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="welcomeBackModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 539px; max-width: 539px;">
                        <div class="modal-content" style="padding-bottom: 15px;">
                            <div class="modal-header">
                                <h5 class="modal-title">Welcome back!</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="welcome-back">
                                    <img src="/themes/web/assets/images/idea.svg" alt="" />

                                    <div class="welcome-back-content">
                                        You’re here again, glad to see you!<br> You have incompleted lessons, don’t forget to complete it!
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-main-border m-auto" style="padding: 8px 15px;">Access to complete it!</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--<div class="modal fade" id="dailyBonusModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="dailyBonusModal" aria-hidden="true">
                    <div class="modal-dialog" style="width: 539px; max-width: 539px;">
                        <div class="modal-content" style="padding-bottom: 15px;">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Daily Bonus</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="daily-bonus">
                                    <div class="daily-bonus-gem">
                                        <div class="text-1">DAY 1</div>
                                        <div class="gem">
                                            <i class="lisa-icon-gem-large"></i>
                                        </div>
                                        <div class="text-2">+30</div>
                                    </div>
                                    <div class="daily-bonus-content">
                                        Don’t forget return everyday, so as not interrupt the chain.
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-main-border m-auto" style="padding: 8px 15px;">Claim</button>
                            </div>
                        </div>
                    </div>
                </div>-->
                <div class="modal fade" id="updateGradeModal" tabindex="-1" role="dialog" aria-labelledby="updateGradeModal" aria-hidden="true" data-backdrop="static" data-keyboard=false>
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content box-shadow-main">
                            <div class="close-popup" data-dismiss="modal"></div>
                            <div class="img-title-">
                                <img src="/themes/web/assets/images/grades.svg" alt="">
                            </div>
                            <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>

                            <div class="grade-select-body">
                                <div class="grade-select-list">
                                    <div @click="selectGrade(6)" :class="checkGradeSelected(6) ? ['grade-select-item', 'active'] : ['grade-select-item']">6
                                    </div>
                                    <div @click="selectGrade(7)" :class="checkGradeSelected(7) ? ['grade-select-item', 'active'] : ['grade-select-item']">7
                                    </div>
                                    <div @click="selectGrade(8)" :class="checkGradeSelected(8) ? ['grade-select-item', 'active'] : ['grade-select-item']">8
                                    </div>
                                    <div @click="selectGrade(9)" :class="checkGradeSelected(9) ? ['grade-select-item', 'active'] : ['grade-select-item']">9
                                    </div>
                                </div>
                            </div>
                            <!-- <p style="color: #f68d69; text-align:center; font-size: 14px" v-if="msg_error!=''">{{ $t(msg_error) }} {{ user_info.placement_test - 1 }}</p> -->
                            <p style="color: #f68d69; text-align:center; font-size: 14px" v-if="msg_error != ''">{{ $t(msg_error) }}</p>
                            <div class="text-center">
                                <button class="lisa-btn-fit active" @click="changeGrade">
                                    {{ $t('confirm') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="placementModal" tabindex="-1" role="dialog" aria-labelledby="placementModal" aria-hidden="true" data-backdrop="static" data-keyboard=false>
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="close-popup" data-dismiss="modal"></div>
                            <div class="img-title-">
                                <img src="/themes/web/assets/images/grades.svg" alt="">
                            </div>
                            <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
                            <br />

                            <div class="grade-select-body">
                                <div class="grade-select-list">
                                    <div @click="selectGrade(6)" :class="checkGradeSelected(6) ? ['grade-select-item', 'active'] : ['grade-select-item']">6
                                    </div>
                                    <div @click="selectGrade(7)" :class="checkGradeSelected(7) ? ['grade-select-item', 'active'] : ['grade-select-item']">7
                                    </div>
                                    <div @click="selectGrade(8)" :class="checkGradeSelected(8) ? ['grade-select-item', 'active'] : ['grade-select-item']">8
                                    </div>
                                    <div @click="selectGrade(9)" :class="checkGradeSelected(9) ? ['grade-select-item', 'active'] : ['grade-select-item']">9
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button class="lisa-btn-fit active" @click="confirmPlacementTest">
                                    {{ $t('do_placement') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="testPlacementModal" tabindex="-1" role="dialog" aria-labelledby="testPlacementModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 650px;">
                        <div class="modal-content box-shadow-main">
                            <div class="close-popup" data-dismiss="modal"></div>
                            <h3 class="popup-title mb-20">{{ $t('placement_test') }}</h3>
                            <div class="d-flex quick-test-box text-center">
                                <img src="/themes/ito/images/reading.svg" style="width: 150px; margin: 0 auto;">
                            </div>
                            <div class="quick-test-bottom box-shadow-main d-flex mt-20">
                                <div class="quick-test-bottom-text">
                                    <div class="txt-2-rows">
                                        <div class="text-right d-inline-block left-title">{{ $t('total') }}:</div>
                                        <div class="d-inline-block right-text">{{ placement_test.total_question }}
                                            {{ $t('scores') }}
                                        </div>
                                    </div>
                                    <div class="txt-2-rows">
                                        <div class="text-right d-inline-block left-title">{{ $t('time_allowance') }}:</div>
                                        <div class="d-inline-block right-text">{{ placement_test.time }} {{ $t('minutes') }}</div>
                                    </div>
                                </div>
                                <div class="ito-btn-large btn-test mt-20" @click="placementTest">
                                    {{ $t('start') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <footer-element />

            <daily-bonus-modal v-if="donePhoneVerifyModal && (!isContestRunning || this.user_info.phone_verified != 0)" :user="user_info" @updateFirstLogin="updateFirstLogin" />
            <event-modal :banners="banners" @hideBanner="hideBanner()" @closeBanner="closeBanner()"></event-modal>
            <ai-tutor v-if="aiTutorConfig" :config="aiTutorConfig" :fullname="user_info.fullname" :username="user_info.username" :grade="grade_selected" />
            <ModalHost />

        </div>
        <mobile-download-app />

        <div class="loading" id="loading" v-if="isLoading">
            <img class="spinner" src="/themes/ito/images/loadding.png" alt="" />
        </div>
    </div>
</template>

<script>
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from "firebase/messaging";
import SideBar from "../SideBar";
import NavBar from "../NavBar";
import FooterElement from "../FooterElement";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
import { getPlacementTest, startPlacementTest } from "../../models/placement_test";
import UpgradeAccountModal from "../modal/UpgradeAccountModal";
import { updateLanguage, getParentSettings, updateSetingNofification, changeGrade } from '../../models/profile';
import axios from "axios";
import DailyBonusModal from '../modal/DailyBonusModal.vue';
import MobileDownloadApp from '../element/MobileDownloadApp.vue';
import { getBanners } from '../../models/dashboard';
import EventModal from '../modal/EventModal.vue';
import AiTutor from '../ai_tutor/AiTutor.vue';
import ModalHost from '@/components/ModalHost.vue'
import UpdateAddressModal from "@/modals/UpdateAddressModal.vue";
import PhoneVerifyModal from "@/modals/PhoneVerifyModal.vue";
import AppIcon from "@/components/common/AppIcon.vue";
import MarqueeText from "@/components/common/MarqueeText.vue";
import moment from 'moment';

export default {
    name: "AppLayout",

    data() {
        const grade_default = localStorage.getItem('grade');
        const configs = getConfigs();
        const localizes = configs.localize || [];
        const banner_hiding = localStorage.getItem('banner_hidden') || localStorage.getItem('banner_close');

        return {
            msg_error: '',
            locate: getLanguage(),
            locate_obj: null,
            user: {
                grade: 1
            },
            grade_selected: grade_default || 1,
            placement_test: {
                id: 0,
                condition_pass: 0,
                time: 0,
                total_question: 0,
            },
            configs: configs,
            localizes: localizes,
            parent_setting: {},
            setting_sound: localStorage.getItem('setting_sound') == 1 ? true : false,
            setting_music_background: localStorage.getItem('setting_music_background') == 1 ? true : false,
            banners: [],
            banner_hiding: JSON.parse(banner_hiding),
            doneUpdateAddressModal: false,
            donePhoneVerifyModal: false,
        };
    },

    components: {
        UpgradeAccountModal,
        FooterElement,
        NavBar,
        SideBar,
        DailyBonusModal,
        MobileDownloadApp,
        EventModal,
        AiTutor,
        ModalHost,
        AppIcon,
        MarqueeText
    },


    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        user_info() {
            return this.$store.state.user_info;
        },
        aiTutorConfig() {
            return this.user_info.package_features?.find(feature => feature.feature_code === 'ai_home_tutor')
        },
        isContestRunning() {
            const contest_info = this.user_info.contest_info;
            if (!contest_info || contest_info.id === 0) {
                return false;
            }
            return true;
        }
    },

    mounted() {
        //setInterval(this.refreshData, 2000);
        // this.grade_selected = this.user_info.grade;
        this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
        localStorage.setItem("banner_close", false);
        this.fetch();
    },

    watch: {
        '$route.path'(newPath) {
            if (newPath !== '/account-verify-phone' && this.$route.path !== '/account-verify-email'
                && this.user_info.phone_verified == 0 && this.user_info.student_type !== 1 && this.doneUpdateAddressModal && this.isContestRunning) {
                this.$modal.open(PhoneVerifyModal, {
                    options: {
                        customSize: {
                            width: '520px',
                            maxWidth: '520px'
                        },
                        centered: true, backdrop: 'static', keyboard: false
                    },
                })
            }
        }
    },

    methods: {
        moment,
        handleGACustomEvent() {
            var element = 'IP2_W_0000'
            var user_id = this.user_info.user_id || '';
            var school_id_ref = this.user_info.school_id_ref || '';
            var grade_id = this.user_info.grade_code || '';
            var class_id = this.user_info.class_code || '';

            var params = {
                'w_user_id': user_id,
                'school_id': school_id_ref,
                'grade_id': grade_id,
                'class_id': class_id
            };
            params[element] = user_id + ((user_id != '') ? '|' : '') + school_id_ref + '|' + grade_id + '|' + class_id;
            gtag('event', element, params);
        },
        // = 0 -> có thể change grade
        // = 1 -> cần hoàn thành các bài học
        // = 2 -> cần làm placement test
        // = 3 -> cần làm final test
        // = 4 -> chưa đủ điều kiện để học lớp này"
        changeGrade() {
            const that = this;
            that.$store.commit("setLoading", true);
            const params = {
                'grade': that.grade_selected
            }
            changeGrade(
                params
            ).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    return;
                }
                switch (parseInt(response.data.results.status)) {
                    case 0:
                        localStorage.setItem('grade', that.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        window.location.href = '/';
                        break;
                    case 1:
                        // this.msg_error = 'You need to pass the final test of grade '+that.user_info.grade_active;
                        this.msg_error = this.$i18n.t('msg_change_grade_1') + " " + that.user_info.grade_active;
                        break;
                    case 2:
                        that.$store.commit("setLoading", true);
                        const path = '/placement-test/' + that.grade_selected;
                        if (that.$route.path !== path) {
                            that.$router.push(path)
                            $('#updateGradeModal').modal("hide");
                        } else {
                            that.$store.commit("setLoading", false);
                            $('#updateGradeModal').modal("hide");
                        }
                        break;
                    case 3:
                        // this.msg_error = 'You need to pass the final test of grade '+that.user_info.grade_active;
                        this.msg_error = this.$i18n.t('msg_change_grade_1') + " " + that.user_info.grade_active;
                        break;
                    case 4:
                        // this.msg_error = 'You can not study grade '+that.grade_selected;
                        this.msg_error = this.$i18n.t('msg_change_grade_2') + " " + that.grade_selected;
                        break;
                    default:
                        $('#updateGradeModal').modal("hide");
                        break;
                }
            });
        },

        getBanners() {
            let params = {}
            axios.all([getBanners(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 0) {
                        return;
                    }
                    var banner = [];
                    const banners = response.data.results || [];
                    banners.forEach((item) => {
                        if (item.category_id == 6) {
                            var image = this.getBannerImage(item.banner_url)
                            item.image = image
                            banner.push(item);
                        }
                    })
                    this.banners = banner;

                    const that = this;
                    let banner_hiding = that.banner_hiding
                    if (!banner_hiding && (banner.length > 0)) {
                        $('#eventModal').modal('show');
                    }
                    if (this.user_info.first_login == 1 && banner_hiding) {
                        $("#dailyBonusModal").modal();
                    }
                })
            );
        },

        getBannerImage(images) {
            images = JSON.parse(images);
            var lang = localStorage.getItem('lang');
            var imageStyleObject = {
                'content': 'url("' + images[lang] + '")',
            }
            return imageStyleObject
        },
        hideBanner() {
            this.banner_hiding = true;
            localStorage.setItem("banner_hidden", true);
        },
        closeBanner() {
            this.banner_hiding = true;
            localStorage.setItem("banner_close", true);
        },

        async fetch() {
            if (this.isContestRunning) {
                if (this.user_info.province.id === 0 || this.user_info.ward.id === 0 || this.user_info.school == '' || this.user_info.class == '') {
                    await this.$modal.open(UpdateAddressModal, {
                        options: {
                            customSize: {
                                width: '500px',
                                maxWidth: '500px'
                            },
                            centered: true, backdrop: 'static', keyboard: false
                        },
                    })
                }
            }
            this.doneUpdateAddressModal = true;
            if (this.user_info.phone_verified == 0 && this.user_info.student_type !== 1 && this.$route.path !== '/account-verify-phone'
                && this.$route.path !== '/account-verify-email' && this.isContestRunning) {
                await this.$modal.open(PhoneVerifyModal, {
                    options: {
                        customSize: {
                            width: '520px',
                            maxWidth: '520px'
                        },
                        centered: true, backdrop: 'static', keyboard: false
                    },
                })
            }
            this.donePhoneVerifyModal = true;
            this.getBanners()
            this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;

            const firebaseConfig = process.env.VUE_APP_ENABLE_GA ? {
                apiKey: "AIzaSyAxzQrUklLLnQaNRf7-5KncyOQhAyy42Z0",
                authDomain: "ismart-lisa.firebaseapp.com",
                projectId: "ismart-lisa",
                storageBucket: "ismart-lisa.appspot.com",
                messagingSenderId: "963982129889",
                appId: "1:963982129889:web:02063b56038f25199795a0",
                measurementId: "G-MQFSPR63VD"
            } : {

            };

            const app = initializeApp(firebaseConfig);
            const messaging = getMessaging(app);
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    getToken(messaging, { vapidKey: 'BGQxkHZzcAhSiVVmIHo1FE5FVqzaVKVOw2hBDu03emmXPIiO5Fg-8V-Xulu6v-SS045k3ZSNEWbnYNyK_s9763k' }).then((currentToken) => {
                        if (currentToken) {
                            window.localStorage.setItem('firebaseToken', currentToken);
                        } else {
                            console.log('No registration token available. Request permission to generate one.');
                        }
                    }).catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);
                    });
                } else {
                    console.log('Unable to get permission to notify.');
                }
            });

            this.handleGACustomEvent();
            const that = this;

            await axios.all([
                getParentSettings()
            ]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }
                that.parent_setting = response.data.results || {};
            }));
        },

        updateFirstLogin(key) {
            this.user_info.first_login = key;
        },

        refreshData() {
            if (this.$refs.audio) {
                this.$refs.audio.play();

                document.getElementById('footer').click();
            }
        },

        updateSetingNofification(e) {
            const that = this;

            const formData = new FormData();

            formData.append('notification_active', that.parent_setting.notification_active == 'activated' ? 0 : 1);

            that.$store.commit("setLoading", true);

            updateSetingNofification(formData).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    alert(response.data.msg)

                    return;
                }
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response)
            });

            e.preventDefault();
        },

        updateSetingSound(e) {
            let setting_sound = localStorage.getItem('setting_sound') == 1 ? true : false;

            setting_sound = setting_sound ? false : true;

            localStorage.setItem('setting_sound', setting_sound ? '1' : '0')
        },
        updateSetingMusic(e) {
            let setting_music = localStorage.getItem('setting_music_background') == 1 ? true : false;

            setting_music = setting_music ? false : true;

            localStorage.setItem('setting_music_background', setting_music ? '1' : '0')
        },

        getSoundClick() {
            soundClick();
        },

        confirmSelectGrade() {
            const that = this;

            that.getSoundClick();
            // console.log(this.user_info.placement_test);
            if (this.user_info.student_type != 1 && this.user_info.placement_test == 0) {
                // if (this.grade_selected == this.user_info.final_test + 1) {
                //     this.msg_error = "msg_final_test_1"
                //     return
                // }else if(this.grade_selected >= this.user_info.final_test + 2){
                //     this.msg_error = "msg_final_test_2"
                //     return
                // }
                localStorage.setItem('grade', this.grade_selected);
                $('#updateGradeModal').modal("hide");
                window.location.href = '/'
            } else {
                if (this.user_info.placement_test - 1 >= this.grade_selected) {
                    // if (this.grade_selected == this.user_info.final_test + 1) {
                    //     this.msg_error = "msg_final_test_1"
                    //     return
                    // }else if(this.grade_selected >= this.user_info.final_test + 2){
                    //     this.msg_error = "msg_final_test_2"
                    //     return
                    // }
                    localStorage.setItem('grade', this.grade_selected);
                    // that.$store.commit("setLoading", this.grade_selected);
                    $('#updateGradeModal').modal("hide");
                    // location.reload();
                    window.location.href = '/'
                } else {
                    // const grade_default = localStorage.getItem('grade');
                    //
                    // this.grade_selected = grade_default || 1;


                    if (this.grade_selected == this.user_info.final_test + 1) {
                        this.msg_error = "msg_final_test_1"
                        return
                    } else if (this.grade_selected >= this.user_info.final_test + 2) {
                        this.msg_error = "msg_final_test_2"
                        return
                    }

                    that.$store.commit("setLoading", true);
                    // :to="{path: '/lesson/'+subject_id+'-'+units.id+'-'+lesson.id}"
                    const path = '/placement-test/' + that.grade_selected
                    if (this.$route.path !== path) {
                        this.$router.push(path)
                        $('#updateGradeModal').modal("hide");
                    } else {
                        that.$store.commit("setLoading", false);
                        $('#updateGradeModal').modal("hide");
                    }

                    // this.$router.push({ path: '/placement-test/'+this.grade_selected });
                    // getPlacementTest({
                    //     grade_id: this.grade_selected
                    // }).then((response) => {
                    //     that.$store.commit("setLoading", false);
                    //
                    //     if (response.data.code != 0) {
                    //         return;
                    //     }
                    //
                    //     this.placement_test = response.data.results[0] || {};
                    //
                    //     console.log(this.placement_test)
                    //
                    //     $('#updateGradeModal').modal("hide");
                    //     $('#testPlacementModal').modal();
                    // }).catch(({response}) => {
                    //     that.$store.commit("setLoading", false);
                    //
                    //     console.error(response);
                    // });
                }
            }
        },
        confirmPlacementTest() {
            const that = this;

            that.getSoundClick();

            // if (this.user_info.grade >= this.grade_selected) {
            //     localStorage.setItem('grade', this.grade_selected);
            //     $('#placementModal').modal("hide");
            //     window.location.href = '/'
            // } else {
            that.$store.commit("setLoading", true);
            const path = '/placement-test/' + that.grade_selected
            if (this.$route.path !== path) {
                this.$router.push(path)
                $('#placementModal').modal("hide");
            } else {
                that.$store.commit("setLoading", false);
                $('#placementModal').modal("hide");
            }
            // }
        },
        placementTest() {
            const that = this;

            that.getSoundClick();

            that.$store.commit("setLoading", true);

            startPlacementTest({
                id: this.placement_test.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#testPlacementModal').modal("hide");
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        selectGrade(grade) {
            this.msg_error = ''
            this.grade_selected = grade;
        },

        checkGradeSelected(grade) {
            return this.grade_selected == grade;
        },

        onLogout(e) {
            this.$store.dispatch('logout').then(() => {
                window.location.href = "/login";
            });
            e.preventDefault();
        },

        setLocate(e) {
            this.getSoundClick();

            this.locate_obj = e;
            this.locate = e.lang;

            //localStorage.setItem('lang', e);
        },

        updateLocate() {
            const that = this;
            this.getSoundClick();
            localStorage.setItem('lang', this.locate);

            if (that.locate_obj != null) {
                that.$store.commit("setLoading", true);
                updateLanguage({
                    id: that.locate_obj.id,
                    is_raw: true
                }).then((response) => {
                    if (response.data.code != 0) {
                        return;
                    }
                    this.$i18n.locale = this.locate

                }).catch(({ response }) => {
                    console.error(response);
                }).finally(() => {
                    that.$store.commit("setLoading", false);
                });
            }
        }
    }
}
</script>
<style scoped>
.modal-content.test-place {
    width: 560px;
    height: 295px;
}

.modal-content.test-place .img-title {
    width: 73.75px;
    height: 57.25px;
    margin-top: 55px;
}

.modal-content.test-place .popup-title {
    font-size: 16px;
    margin-top: 45px;
    margin-bottom: 0;
    padding-bottom: 0;
}

#placementModal .grade-select-list {
    margin-top: -12px;
}

#updateGradeModal .grade-select-list {
    margin-top: 3px;
}

#confirmLogout .modal-content {
    text-align: center;
}

#updateGradeModal .modal-content.test-place {
    height: 310px;
}

.img-title>img {
    width: 75px;
    height: 80px;
}

#updateGradeModal .modal-content {
    width: 468px;
    height: 313px;
    padding: 16px 64px 20px;
}

#updateGradeModal .grade-select-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    margin-right: 12px;
}

#updateGradeModal .grade-select-item.active {
    background: #08A6FF;
}

#updateGradeModal .grade-select-item:last-child {
    margin-right: 0;
}

#updateGradeModal .lisa-btn-fit {
    display: flex;
    align-items: center;
    height: 35px;
}

#updateGradeModal .popup-title {
    margin: 0px auto 20px;
    font-size: 16px;
}

#updateGradeModal .img-title- {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
}

#updateGradeModal .grade-select-list {
    margin-bottom: 12px;
}





#placementModal .modal-content {
    width: 468px;
    height: 289px;
    padding: 16px 64px 20px;
}

#placementModal .grade-select-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    margin-right: 12px;
}

#placementModal .grade-select-item.active {
    background: #08A6FF;
}

#placementModal .grade-select-item:last-child {
    margin-right: 0;
}

#placementModal .lisa-btn-fit {
    display: flex;
    align-items: center;
    height: 35px;
}

#placementModal .popup-title {
    margin: 0px auto 20px;
    font-size: 16px;
}

#placementModal .img-title- {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
}

#placementModal .grade-select-list {
    margin-bottom: 12px;
}

.left-corner {
    position: fixed;
    width: 13vw;
    max-width: 163px;
    z-index: 2;
    bottom: 30px;
    left: 105px;
    animation: 1s ease-out 0s 1 slideInFromLeft;
    content: var(--left-corner-image);
}

.right-corner {
    position: fixed;
    width: 13vw;
    max-width: 177px;
    top: 85px;
    right: 23px;
    animation: 1s ease-out 0s 1 slideInFromRight;
    content: var(--right-corner-image);
}


.banner-text {
    width: calc(100% - 5px);
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 84px;
    z-index: 1;
    height: 47px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.7);

    animation-name: slidedown;
    animation-duration: 1s;
}

.banner-text .banner-link {
    color: #F04821;
    text-align: center;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
    /* text-decoration-line: underline; */
}

.banner-text span.banner-btn {
    display: inline-block;
    box-shadow: 0px 2px 0px 0px #ffffff33 inset;
    box-shadow: 4px 4px 0px 0px #0000000d;
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-align: center;
    color: #FFFFFF !important;
    padding: 8px 12px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 30px;
    margin-left: 10px;
}

@keyframes slidedown {
    from {
        top: 47px;
    }

    to {
        top: 65px;
    }
}


@media screen and (max-width: 1366px) {

    .left-corner,
    .right-corner {
        display: none;
    }
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(0);
    }
}

.show-destop {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    font-family: "Nunito", sa
}

.btn.btn-orange-gradient {
    background: linear-gradient(180deg, #FF8C69 0%, #FA450F 100%) !important;
    border: none;
    color: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 0px 0px #FFFFFF33 inset;
    box-shadow: 4px 4px 0px 0px #0000000D;
}

.btn.btn-orange-gradient:hover {
    background: linear-gradient(135deg, #FF9535 0%, #FF6B35 100%) !important;
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
}
</style>